import angular from 'angular';
import { RogersRecruitingBonusReportContainerComponent } from './rogers-recruiting-bonus-report-container.component';
import { RogersRecruitingBonusReportComponent } from './rogers-recruiting-bonus-report.component';
import { RogersRecruitingBonusBreakdownReportComponent } from './rogers-recruiting-bonus-breakdown-report.component';

export const RogersRecruitingBonusReportModule = angular
    .module("apex.mainApp.rogersDashboard.recruitingBonusReport", [])
    .component("apexRogersRecruitingBonusReportContainer", RogersRecruitingBonusReportContainerComponent)
    .component("apexRogersRecruitingBonusReport", RogersRecruitingBonusReportComponent)
    .component("apexRogersRecruitingBonusBreakdownReport", RogersRecruitingBonusBreakdownReportComponent)
    .name;
